import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';

export function SortableServiceItem({ service }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: service.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex items-start gap-3 p-4 bg-slate-100 dark:bg-charcoal border border-light-border dark:border-border rounded-xl"
    >
      <div
        {...attributes}
        {...listeners}
        className="mt-1 cursor-grab active:cursor-grabbing text-slate-400 dark:text-silver/60 hover:text-slate-600 dark:hover:text-silver transition-colors"
      >
        <GripVertical className="w-5 h-5" />
      </div>
      <div className="flex-1">
        <div className="font-body text-sm text-light-text dark:text-pure-white font-medium">
          {service.name}
        </div>
        <div className="font-mono text-xs text-slate-400 dark:text-silver/60 mt-1">
          {service.currency}{service.price} · {service.durationMinutes} minutes
        </div>
        {service.description && (
          <div className="font-body text-xs text-slate-400 dark:text-silver/60 mt-1">
            {service.description}
          </div>
        )}
      </div>
    </div>
  );
}
